import PropTypes from 'prop-types'
import React from 'react'

const WordlistPrintedTable = ({
  title,
  listName,
  languages,
  // defaultLanguageId,
  selectedEntries,
}) => {
  return (
    <div>
      <div>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            border: 'none',
            fontFamily: 'sans-serif',
            boxSizing: 'border-box',
            tableLayout: 'fixed',
          }}
        >
          <colgroup>
            {languages.map(language => {
              return (
                <col
                  key={language.id}
                  width={`${100 / languages.length}%`}
                />
              )
            })}
          </colgroup>
          <thead>
            <tr>
              <th
                colSpan={languages.length}
                style={{
                  textAlign: 'center',
                  fontWeight: 'normal',
                  padding: '.5rem',
                  paddingBottom: '1rem',
                }}
              >
                {`${title}${
                  listName ? ` – ${listName}` : ''
                }`}
              </th>
            </tr>
            <tr>
              {languages.map(language => {
                return (
                  <th
                    key={language.id}
                    style={{
                      textAlign: 'left',
                      padding: '.5rem',
                      border: 'none',
                      borderBottom: '1pt solid silver',
                      boxSizing: 'border-box',
                    }}
                  >
                    {language.label}
                  </th>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {selectedEntries.map(entry => {
              return (
                <tr key={entry.id}>
                  {languages.map(language => {
                    let value =
                      (entry.values[language.id] &&
                        entry.values[language.id].value) ||
                      ''
                    return (
                      <td
                        key={language.id}
                        className={
                          language.code === 'zxx-image'
                            ? 'print-image'
                            : ''
                        }
                        style={{
                          padding: '.5rem',
                          border: 'none',
                          borderBottom: '1pt solid silver',
                          boxSizing: 'border-box',
                        }}
                      >
                        {language.code.indexOf('zxx-image') !== -1 && value ? (
                          <img
                            alt=""
                            src={value.replace('https://pedagogvarmland.se/sites/default/files/skolord/', wpApiSettings.wp_theme_url + '/static/images/skolord/')}
                            style={{ maxHeight: language.code.indexOf('zxx-image-') !== -1 ? language.code.substring(10)+'px' : '50px' }}
                          />
                        ) : (
                          value
                        )}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

WordlistPrintedTable.propTypes = {
  title: PropTypes.string.isRequired,
  listName: PropTypes.string,
  languages: PropTypes.array.isRequired,
  selectedEntries: PropTypes.array.isRequired,
  totalEntries: PropTypes.number.isRequired,
}

export default WordlistPrintedTable
